import { createOperatorLocationsService } from "api-client";

/** Operator-scoped locations dropdown: `GET .../Operator/locations/dropdown`. */
export const locationsService = createOperatorLocationsService();
